<div class="casilla-resumen container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card p-3">
                <div class="row img-esquina">
                    <div class="col-12 col-lg-10">
                        <app-breadcrumb
                            subtitle_detalle="Voto en Prisión Preventiva"
                            [estado]="_obtenerDatosService?.config?.estado"
                            [distrito]=""
                            [distrito_param]=""
                            seccion=""
                            fromAntiPrev="true"
                        ></app-breadcrumb> 
                        <div class="texto font-regular d-block">
                            <p>El total de votos calculado y porcentaje que se muestran, se refieren a los votos asentados en las Actas de Escrutinio y Cómputo del Voto de Personas en Prisión Preventiva hasta el momento.</p>
                            <br class="d-block d-xl-none">
                            <p>Por presentación, los decimales de los porcentajes muestran sólo cuatro digitos. No obstante, al considerar todos los decimales, suman 100%</p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-10 mb-4">
                    </div>
                </div>
                    
                <div class="row d-none d-md-none d-xl-block">
                    <div class="col">

                        <h4 class="subtitulo-seccion pleca-izquierda">
                            <strong>Votos en Actas Contabilizadas</strong>
                        </h4>
                    </div>
                </div>

                <!-- <div class="acta-digitalizada container-fluid pb-3">
                    <div class="row d-none d-none d-xl-flex">
                        <div class="col-3 col-xl-2 ">
                            <p class="pb-3">Acta digitalizada:</p>
                            <a *ngIf="(objCasilla?.status?.scanner || objCasilla?.status?.movil || objCasilla?.status?.catd)" target="_blank" [href]="actasRoot + (objCasilla?.status?.scanner ? objCasilla?.status?.scanner : (objCasilla?.status?.movil ? objCasilla?.status?.movil : (objCasilla?.status?.catd ? objCasilla?.status?.catd : '')))">
                                <button class="btn boton-rosa txBlanco custom-wd" [disabled]="(!objCasilla?.status?.scanner && !objCasilla?.status?.movil && !objCasilla?.status?.catd)">
                                    <div style="display: inline-flex;">
                                        <i *ngIf="!objCasilla?.status?.catd" class="far fa-file" aria-hidden="true"></i>
                                        <i *ngIf="!objCasilla?.status?.catd" aria-hidden="true" [ngClass]="{fas: (objCasilla?.status?.scanner || objCasilla?.status?.movil), 'far': (!objCasilla?.status?.scanner && !objCasilla?.status?.movil), 'fa-print' : objCasilla?.status?.scanner, 'fa-mobile-alt': (objCasilla?.status?.movil && !objCasilla?.status?.scanner), 'fa-hourglass': (!objCasilla?.status?.scanner && !objCasilla?.status?.movil)}"></i>
                                        <img *ngIf="objCasilla?.status?.catd" src="./assets/img/generales/movil_catd_white.svg" height="16" style="margin-right: 4px;">
                                        <span *ngIf="objCasilla?.status && objCasilla?.status != 'sin_acta'">&nbsp;Ver</span>
                                        <span *ngIf="objCasilla?.status && objCasilla?.status == 'sin_acta'">&nbsp;Sin Acta</span>
                                    </div>
                                </button>
                            </a>
                            <button *ngIf="(!objCasilla?.status?.scanner && !objCasilla?.status?.movil && !objCasilla?.status?.catd)" class="btn boton-rosa txBlanco custom-wd" [disabled]="(!objCasilla?.status?.scanner && !objCasilla?.status?.movil && !objCasilla?.status?.catd)">
                                <div style="display: inline-flex;">
                                    <i *ngIf="!objCasilla?.status?.catd" class="far fa-file" aria-hidden="true"></i>
                                    <i *ngIf="!objCasilla?.status?.catd" aria-hidden="true" [ngClass]="{fas: (objCasilla?.status?.scanner || objCasilla?.status?.movil), 'far': (!objCasilla?.status?.scanner && !objCasilla?.status?.movil), 'fa-print' : objCasilla?.status?.scanner, 'fa-mobile-alt': (objCasilla?.status?.movil && !objCasilla?.status?.scanner), 'fa-hourglass': (!objCasilla?.status?.scanner && !objCasilla?.status?.movil)}"></i>
                                    <img *ngIf="objCasilla?.status?.catd" src="./assets/img/generales/movil_catd_white.svg" height="16" style="margin-right: 4px;">
                                    <span *ngIf="objCasilla?.status && objCasilla?.status != 'sin_acta'">&nbsp;Ver</span>
                                    <span *ngIf="objCasilla?.status && objCasilla?.status == 'sin_acta'">&nbsp;Sin Acta</span>
                                </div>
                            </button>
                        </div>

                        <div class="col-9 col-xl-6">
                            <p class="font-medium pb-3">
                                &nbsp; Imagen procedente de:
                            </p>
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-3 dis-flex border-rightB padding-r-0">
                                        <div class="grupo gris dis-flex">
                                            <i class="far fa-file" aria-hidden="true" style="margin-right: 4px;"></i>
                                            <i class="fas fa-print" aria-hidden="true"></i>
                                            <p>
                                                Escáner
                                            </p>
                                        </div>
                                    </div>

                                    <div class="col-3 dis-flex border-rightB padding-r-0">
                                        <div class="grupo gris dis-flex">
                                            <i class="far fa-file" aria-hidden="true" style="margin-right: 4px;"></i>
                                            <i class="fas fas fa-mobile-alt" aria-hidden="true"></i>
                                            <p>
                                                Movil
                                            </p>

                                            <div class="vline" style="margin-left: 45px;"></div>
                                        </div>
                                    </div>

                                    <div class="col-4 dis-flex">
                                        <div class="grupo gris dis-flex" placement="top"
                                            max-width="500">
                                            <i style="font-size: 1.4em;" class="far fa-file icon-size"></i>
                                            <i style="font-size: 1.4em;" class="far fa-hourglass icon-size"></i>
                                            <p>
                                                Acta en proceso
                                            </p>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <!-- <div class="row d-block d-md-block d-xl-none">
                        <div class="col-6 col-xl-6 border-right">
                            <p class="pb-3">Ver Acta digitalizada en:</p>
                            <a *ngIf="(objCasilla?.status?.scanner || objCasilla?.status?.movil || objCasilla?.status?.catd)"
                                target="_blank" [href]="actasRoot + (objCasilla?.status?.scanner ? objCasilla?.status?.scanner : (objCasilla?.status?.movil ? objCasilla?.status?.movil : ''))">
                                <button class="btn boton-rosa txBlanco custom-wd" [disabled]="(!objCasilla?.status?.scanner && !objCasilla?.status?.movil)">
                                    <i class="far fa-file" aria-hidden="true"></i>
                                    <i class="fas" aria-hidden="true" [ngClass]="{'fa-print' : objCasilla?.status?.scanner, 'fa-mobile-alt': (objCasilla?.status?.movil && objCasilla?.status?.scanner), 'fa-hourglass': (!objCasilla?.status?.scanner && objCasilla?.status?.movil)}"></i>
                                    Ver
                                </button>
                            </a>
                            <button *ngIf="(!objCasilla?.status?.scanner && !objCasilla?.status?.movil && !objCasilla?.status?.catd)" class="btn boton-rosa txBlanco custom-wd" [disabled]="(!objCasilla?.status?.scanner && !objCasilla?.status?.movil)">
                                <i class="far fa-file" aria-hidden="true"></i>
                                <i class="fas" aria-hidden="true" [ngClass]="{'fa-print' : objCasilla?.status?.scanner, 'fa-mobile-alt': (objCasilla?.status?.movil && objCasilla?.status?.scanner), 'fa-hourglass': (!objCasilla?.status?.scanner && objCasilla?.status?.movil)}"></i>
                                Ver
                            </button>
                        </div>
                    </div>
                </div> -->
                <!--************************ TARJETAS EN ESCRITORIO ***********************-->
                <div class="container-fluid d-none d-md-none d-xl-block">
                    <div class="row dis-flex pb-1">
                        <div class="boton-scroll dis-flex cursorPointer" (click)="scrollLeft()">
                            <i class="fas fa-chevron-left" aria-hidden="true"></i>
                        </div>
                        <div class="col-11">
                            <div #widgetsContent class="row dis-flex justify-s scrollH">
                                <div *ngFor="let tarjeta of fichas; let i=index"
                                    class="col-6 col-sm-4 col-md-3 col-lg-2 px-1">
                                    <div class="card-resumen">
                                        <div class="encabezado dis-flex w-100 py-2">
                                            <div class="dis-flex w-100">
                                                <div class="row w-100 dis-flex">
                                                    <img *ngFor="let img of tarjeta?.imgs" class="img-partido" src="{{_obtenerDatosService.pathPartidos}}{{img}}">
                                                    <!-- <p class="pe p-1" *ngFor="let img of tarjeta?.imgs" [ngStyle]="{
                                                        'background-image': 'url(./assets/img/logos-partidos/'+  img +')',
                                                        'background-size': 'contain',
                                                        'background-repeat': 'no-repeat',
                                                        'background-position': 'center',
                                                        'margin': '20px 2px'
                                                    }">
                                                    </p> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="cuerpo dis-flex bgGrisTenue p-2">
                                            <div class="w-50">
                                                <p>Votos</p>
                                                <p class="votos">
                                                    <strong>{{ tarjeta?.total }}</strong>
                                                </p>
                                            </div>
                                            <!-- <div class="w-50 dis-flex flex-col align-e pr-3 pr-xl-0"> -->
                                                <!-- <p>&nbsp;</p>
                                                <p>{{ tarjeta?.porcentaje}}</p> -->
                                                <!-- <p class="estadistica-label" >&nbsp;</p>
                                                <p class="estadistica-val">&nbsp;</p>
                                            </div> -->
                                            <div class="w-50 dis-flex flex-col align-e pr-3 pr-xl-0">
                                                <p>Porcentaje</p>
                                                <p>{{ tarjeta?.porcentaje ? tarjeta?.porcentaje : (tarjeta?.prc ? tarjeta?.prc : 0) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="boton-scroll dis-flex cursorPointer" (click)="scrollRight()">
                            <i class="fas fa-chevron-right" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>

                <!--********************************************************************************************************************-->
                        <app-resumen-votacion class="d-none d-xl-block"
                            [extranjero_num]="resumen?.extranjero?.total"
                            [extranjero_prc]="resumen?.extranjero?.prc"
                            [hide_acumulados]="false"
                            [acumulados_num]="resumen?.acumulados?.total"
                            [acumulados_prc]="resumen?.acumulados?.prc"
                            [noregistradas_num]="resumen?.no_registradas?.total"
                            [noregistradas_prc]="resumen?.no_registradas?.prc"
                            [nulos_num]="resumen?.nulos?.total"
                            [nulos_prc]="resumen?.nulos?.prc"
                            [total_num]="resumen?.total?.total"
                            [total_prc]="resumen?.total?.prc"
                            [use_observaciones]="false"
                            [hide_prc]="false"
                            [hide_legend]="false"
                        ></app-resumen-votacion>

                <div class="row d-none d-md-none d-xl-block">
                    &nbsp;
                </div>
                
            </div>
        </div>
    </div>
    <div style="display: flex !important; flex-direction: column; width: 100%; height: 200px;">
        <p style="flex: 1;">
        &nbsp;
        </p>
    </div>
    <!--********************* TABLA MOVIL *********************-->
    <div class="row d-block d-md-block d-xl-none">
        <div class="col-12">
            <h4 class="subtitulo-seccion pleca-izquierda">
                <strong>Votos en Acta Contabilizada</strong>
            </h4>
        </div>
        <div class="row mb-5" *ngIf="selectedOptionIndx == -1">
            <div class="w-100 dis-flex table-movil py-2 pl-4" *ngFor="let item of fichas; let indx = index;" >
                <table class="w-100 ">
                    <tr>
                        <td class="w-col">
                            <img class="logo" height="30px" *ngIf="item.imgs?.length > 0" 
                                src="{{_obtenerDatosService.pathPartidos}}{{item.imgs[0]}}"/>
                        </td>
                        <td class="w-col">
                            <p class="label-votos">Votos</p>
                            <p class="votos"><strong>{{ item?.total }}</strong></p>
                        </td>
                        <td class="w-col">
                            <!-- <p class="label-votos align-center"><br>&nbsp;</p> -->
                            <p class="label-votos">Porcentaje</p>
                            <p class="votos"><strong>{{ item?.prc }}</strong></p>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
    <app-resumen-votacion class="d-block d-xl-none"
        [acumulados_num]="resumen?.acumulados?.total"
        [acumulados_prc]="resumen?.acumulados?.prc"
        [extranjero_num]="resumen?.acumulados?.total"
        [extranjero_prc]="resumen?.extranjero?.prc"
        [hide_acumulados]="true"
        [noregistradas_num]="resumen?.no_registradas?.total"
        [noregistradas_prc]="resumen?.no_registradas?.prc"
        [nulos_num]="resumen?.nulos?.total"
        [nulos_prc]="resumen?.nulos?.prc"
        [total_num]="resumen?.total?.total"
        [total_prc]="resumen?.total?.prc"
        [hide_prc]="true"
        [extranjero]="true"
        [use_acumulados]="true"
    ></app-resumen-votacion>
    <!--*****************************************************************-->

    <div class="d-block d-xl-none">
        <app-resumen-votacion-mobile
            [total_num]="resumen?.total?.total"
            [total_prc]="resumen?.total?.prc"
            [hide_prc]="true">
        </app-resumen-votacion-mobile>
    </div>

    <!--    <div class="card p-3">-->
    <div class="row">
        <div class="col-md-12">
            &nbsp;
        </div>
    </div>
    <!--    </div>-->
</div>